package com.bikompanion.data

internal actual fun systemTimeZoneId(): String? =
    js("Intl.DateTimeFormat().resolvedOptions().timeZone") as? String
